import { render } from "./slots.vue?vue&type=template&id=0e8d6af8&scoped=true"
import script from "./slots.vue?vue&type=script&lang=js"
export * from "./slots.vue?vue&type=script&lang=js"

import "./slots.vue?vue&type=style&index=0&id=0e8d6af8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8d6af8"]])

export default __exports__